import React, { forwardRef } from "react";
import { Box, SxProps } from "@mui/material";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import { useTranslation } from "react-i18next";
import { customColors } from "src/theme";

interface LogoutButtonProps {
  onClick: () => void;
  isBackgroundLight: boolean;
  sx?: SxProps;
}

export const LogoutButton = forwardRef<HTMLButtonElement, LogoutButtonProps>(
  ({ onClick, isBackgroundLight, sx = {}, ...props }, ref) => {
    const { t } = useTranslation();
    return (
      <Box sx={{ width: "125px", display: "flex", justifyContent: "flex-end" }}>
        <Box
          component="button"
          ref={ref}
          onClick={onClick}
          {...props}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "45px",
            height: "45px",
            border: "none",
            borderRadius: "50%",
            cursor: "pointer",
            position: "relative",
            overflow: "hidden",
            transitionDuration: "0.3s",
            boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: isBackgroundLight
              ? "transparent"
              : "rgba(0, 0, 0, 0.3)",
            "&:hover": {
              width: "125px",
              borderRadius: "40px",
            },
            "&:active": {
              transform: "translate(2px, 2px)",
            },
            ...sx,
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: "100%",
              transitionDuration: "0.3s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: isBackgroundLight
                ? customColors.textAccent
                : customColors.headerText,
              ".MuiBox-root:hover &": {
                width: "30%",
                paddingLeft: "20px",
              },
              "& svg": {
                fontSize: "20px",
              },
            }}
          >
            <LogoutOutlined />
          </Box>

          {/* Text */}
          <Box
            sx={{
              position: "absolute",
              right: "0%",
              width: "0%",
              opacity: 0,
              color: isBackgroundLight
                ? customColors.textAccent
                : customColors.headerText,
              fontSize: "16px",
              whiteSpace: "nowrap",
              fontWeight: 500,
              transitionDuration: "0.3s",
              marginLeft: "6px",
              ".MuiBox-root:hover &": {
                opacity: 1,
                width: "70%",
                paddingRight: "10px",
              },
            }}
          >
            {t("NAV.LOGOUT")}
          </Box>
        </Box>
      </Box>
    );
  }
);

LogoutButton.displayName = "LogoutButton";
